import { c as _c } from "react/compiler-runtime";
import { Box, Heading } from '@chakra-ui/react';
import { ProgressCircleRing, ProgressCircleRoot } from '@src/components/chakra-ui/progress-circle';
import { scoreColorPalette } from '@src/components/sco/PitchDeckAuditor/model/ratingMeta';
type ScoreRingProps = {
  score: number | null | undefined;
  size?: string;
  thickness?: string;
  headingSize?: string;
};

/** A circular score gauge (0–100). Renders an em-dash when no score is available. */
export function ScoreRing(t0) {
  const $ = _c(15);
  const {
    score,
    size: t1,
    thickness,
    headingSize: t2
  } = t0;
  const size = t1 === undefined ? "xl" : t1;
  const headingSize = t2 === undefined ? "lg" : t2;
  const value = typeof score === "number" ? score : 0;
  let t3;
  if ($[0] !== score) {
    t3 = scoreColorPalette(score);
    $[0] = score;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = size as any;
  let t5;
  if ($[2] !== thickness) {
    t5 = thickness ? {
      "--thickness": thickness
    } : undefined;
    $[2] = thickness;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t5) {
    t6 = <ProgressCircleRing cap="round" css={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = headingSize as any;
  const t8 = typeof score === "number" ? score : "\u2014";
  let t9;
  if ($[6] !== t7 || $[7] !== t8) {
    t9 = <Box alignItems="center" display="flex" inset={0} justifyContent="center" position="absolute"><Heading lineHeight={1} size={t7}>{t8}</Heading></Box>;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t6 || $[12] !== t9 || $[13] !== value) {
    t10 = <ProgressCircleRoot colorPalette={t3} size={t4} value={value}>{t6}{t9}</ProgressCircleRoot>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
    $[12] = t9;
    $[13] = value;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
}